import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgFor } from "@angular/common";

@Component({
    selector: "app-loading-grid",
    standalone: true,
    imports: [NgFor],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./loading-grid.component.html",
    styleUrl: "./loading-grid.component.scss",
})
export class LoadingGridComponent {
    @Input() count = 3;

    get placeholders(): number[] {
        return Array.from({ length: this.count }, (_, i) => i);
    }
}
